import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useGame } from '../context/GameContext';
import { NoirBackground, Button, GameCard, CounterButton, Pill } from '../components/GameUI';
import { ArrowRight } from 'lucide-react';
import { toast } from 'sonner';

const Setup = () => {
  const { setTotalPlayers, civilianCount, setCivilianCount, imposterCount, setImposterCount,
    mrWhiteCount, setMrWhiteCount, setGameState, showRoles, setShowRoles } = useGame();
  const [lc, setLc] = useState(civilianCount);
  const [li, setLi] = useState(imposterCount);
  const [lm, setLm] = useState(mrWhiteCount);
  const total = lc + li + lm;
  const isValid = total >= 3 && lc >= 1 && li >= 1;

  const go = () => {
    if (!isValid) { toast.error('Invalid configuration'); return; }
    setTotalPlayers(total); setCivilianCount(lc); setImposterCount(li); setMrWhiteCount(lm);
    setGameState('nameEntry');
  };

  return (
    <div className="min-h-dvh flex flex-col items-center p-6 pb-32 relative select-none">
      <NoirBackground />
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md space-y-5 pt-12 relative z-10">
        <div>
          <div className="font-mono text-[#5A5A5A] text-xs uppercase tracking-[0.3em] mb-2">Configuration</div>
          <h1 className="font-typewriter text-5xl text-[#E0DDD5] leading-none">Case Setup</h1>
          <div className="red-line w-full mt-3" />
        </div>
        <div className="space-y-3">
          <CounterButton label="Civilians" value={lc} dotColor="#E0DDD5"
            onDecrease={() => setLc(Math.max(1, lc - 1))} onIncrease={() => setLc(lc + 1)} />
          <CounterButton label="Imposters" value={li} dotColor="#EF4444"
            onDecrease={() => setLi(Math.max(1, li - 1))} onIncrease={() => setLi(li + 1)} />
          <CounterButton label="Mr. White" value={lm} dotColor="#FFFFFF"
            onDecrease={() => setLm(Math.max(0, lm - 1))} onIncrease={() => setLm(lm + 1)} />
        </div>
        <GameCard className="flex items-center justify-between p-5">
          <div>
            <div className="text-[#E0DDD5] font-bold text-sm">Reveal Identities</div>
            <div className="text-[#5A5A5A] text-xs mt-0.5 font-mono">{showRoles ? 'Show roles' : 'Words only'}</div>
          </div>
          <button data-testid="toggle-show-roles-btn" onClick={() => setShowRoles(!showRoles)}
            className={`relative w-12 h-6 rounded-full transition-colors ${showRoles ? 'bg-[#DC2626]' : 'bg-[#222]'}`}>
            <div className={`absolute top-0.5 w-5 h-5 rounded-full bg-[#E0DDD5] transition-all ${showRoles ? 'left-6' : 'left-0.5'}`} />
          </button>
        </GameCard>
        <div className="text-center">
          <Pill color={isValid ? 'red' : 'dark'}>{total} Suspects{total < 3 ? ' — need 3+' : ''}</Pill>
        </div>
      </motion.div>
      <div className="fixed bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-[#080808] via-[#0A0A0A]/95 to-transparent z-20">
        <div className="max-w-md mx-auto">
          <Button data-testid="continue-setup-btn" color="red" disabled={!isValid} onClick={go}>
            <span className="flex items-center justify-center gap-2">Proceed <ArrowRight size={18} /></span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Setup;
